import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { LoginService } from '../../core/services/login.service';
import { ViewStateService } from '../../core/services/view-state.service';
import { FeatureFlagsService } from '../../core/services/feature-flags.service';
import { firstValueFrom } from 'rxjs';

declare let require: any;

@Component({
  selector: 'ng-login-callback',
  template: require('./ng-login-callback.component.html').default,
  styles: [require('!!raw-loader!sass-loader!./ng-login-callback.component.scss').default],
  standalone: false,
})
export class NgLoginCallbackComponent implements OnInit {
  constructor(
    @Inject(Router) private router: Router,
    @Inject(AuthService) private authService: AuthService,
    @Inject(LoginService) private loginService: LoginService,
    @Inject(ViewStateService) private viewState: ViewStateService,
    @Inject(FeatureFlagsService) private featureFlags: FeatureFlagsService
  ) {}

  ngOnInit(): void {
    this.authService.getUser().subscribe({
      next: (success) => {
        this.loginService.IsLoggedIn(success.username, success);
        firstValueFrom(this.featureFlags.load(true)).finally(() => {
          this.router.navigateByUrl(this.viewState.getLastRouteOrFallback());
        });
      },
      error: (error) => {
        console.error('Login callback failed:', error);
        this.router.navigate(['/login']);
      },
    });
  }
}
